import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, TypographyTagVariants } from '@components/atoms/Typography';
import { Container } from '@components/atoms/Container';
import { Anchor, AnchorMode } from '@components/atoms/Anchor';
import { useThemes } from '@hooks/useThemes';
import styles from './ShoppingCartHeader.module.css';
import { useData } from '@hooks/useData';

export interface ShoppingCartHeaderProps {
    activeStep: number;
}

export const ShoppingCartHeader: FC<ShoppingCartHeaderProps> = ({ activeStep }) => {
    const { useGrayscaleTheme } = useThemes();
    const { t } = useTranslation();

    const { allSettings } = useData();
    const data = allSettings?.data;

    const translations = [
        t('shopping-cart-header-component.step.basket'),
        t('shopping-cart-header-component.step.billing'),
        t('shopping-cart-header-component.step.deliveryAddress'),
        t('shopping-cart-header-component.step.payment'),
        t('shopping-cart-header-component.step.confirm'),
    ];

    const logoItem = data?.layouts?.find((item) => item.name === 'logo');
    const logoSrc = logoItem?.value;

    return (
        <header
            className={`${styles['shopping-cart-steps']} ${useGrayscaleTheme ? styles['theme-grayscale'] : ''}`}
            data-testid="shopping-cart-header">
            <Container classes="px-0">
                <>
                    <div className="d-flex flex-column flex-md-row align-items-center justify-content-center justify-content-lg-start position-relative">
                        {/* go back to previous page - on smaller screens */}
                        <button className={`${styles['go-back']} d-block d-md-none`} onClick={() => window.history.back()}>
                            <i className="fa-thin fa-arrow-left"></i>
                        </button>
                        {/* logo */}
                        <Anchor href="" classes={styles['logo-container']} mode={AnchorMode.none}>
                            <img className={styles['brand-logo']} src={logoSrc} alt={allSettings?.data?.marketplaceName} />
                        </Anchor>
                        {/* steps */}
                        <div className={`nav ${styles['nav']}`}>
                            <ul>
                                {translations.map((stepName, index) => {
                                    const currentStep = index + 1;
                                    return (
                                        <li
                                            key={`step-${currentStep}`}
                                            className={currentStep === activeStep ? styles.active : ''}>
                                            <Typography
                                                classes={styles['number']}
                                                tagVariant={TypographyTagVariants.span}
                                                fontSize="12">
                                                {`${currentStep}`}
                                            </Typography>
                                            <Typography
                                                classes={styles['text']}
                                                tagVariant={TypographyTagVariants.span}
                                                fontSize="10"
                                                breakpointsStyles={{ xl: { fontSize: '12' } }}>
                                                {stepName}
                                            </Typography>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </div>
                </>
            </Container>
        </header>
    );
};
